module.exports = __webpack_public_path__ + "static/media/lessThanWhite.2fb833da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/lessThanWhite.svg
// module id = 111
// module chunks = 27